import axios from 'axios';
import { Bridge } from '@/utils/bridge';
import { setOptions } from './axios.config';
import { API_RESPONSE_STATUS_CODE } from '@/configs/common';
import { awsRumHandler } from '@/utils/awsRumHandler';
import { isInArray } from '@/utils/common';
import { AXIOS_CONFIG } from '@/configs/common';
// Create an axios instance
const https = axios.create({
  timeout: AXIOS_CONFIG.TIMEOUT_DEFAULT
});
axios.defaults.withCredentials = false;

const isRequiredIncreaseTimeOut = option => {
  const { url } = option;
  const needIncreaseTimeOutUrls = [
    '/orders/createPurchase',
    '/config/category',
    '/orders/setReturnTransportationAndSign'
  ];
  return isInArray(url, needIncreaseTimeOutUrls);
};

const requestConfig = config => {
  if (isRequiredIncreaseTimeOut(config)) {
    config.timeout = AXIOS_CONFIG.TIMEOUT_MAX;
  }
  config.meta = 'meta' in config ? config.meta : {};
  config.meta.requestStartedTime = new Date().getTime();
  return config;
};

const requestError = error => {
  return Promise.reject(error);
};
// Add a request interceptor
https.interceptors.request.use(requestConfig, requestError);

const handleSuccessfulResponse = res => {
  awsRumHandler.recordResponseDuration(res);
  return Promise.resolve(res);
};
const handleErrorResponse = error => {
  awsRumHandler.recordResponseDuration(error);
  if (error.response.status === API_RESPONSE_STATUS_CODE.UNAUTHORIZED) {
    Bridge.callFn('onAccessTokenInvalid', {});
  }
  return Promise.reject(error.response);
};
// Add a response interceptor
https.interceptors.response.use(handleSuccessfulResponse, handleErrorResponse);

export default {
  async post(url, params, headers = {}) {
    const options = await setOptions(headers, { url });
    return https.post(url, params, options);
  },
  async get(url, params, headers = {}) {
    const options = await setOptions(headers, { url });
    return https.get(url, { params, headers: options.headers });
  },
  async put(url, params, headers = {}) {
    const options = await setOptions(headers, { url });
    return https.put(url, params, options);
  },
  requestConfig,
  requestError,
  handleSuccessfulResponse,
  handleErrorResponse
};
